import { colors, typography } from '@insurancemenu/imenu-components-lib';
import { breakpointsMQ4 } from '@insurancemenu/imenu-components-lib/dist/utils/breakpoints';
import styled from 'styled-components';

export const GeneralStatisticsWrapperStyled = styled.ul`
  list-style: none;
  display: flex;
  flex-wrap: wrap;
  justify-content: space-between;
  gap: 4rem;
  margin: 0 0 6rem;
  padding: 0;

  ${breakpointsMQ4.md.down} {
    flex-direction: column;
    align-items: stretch;
  }
`;

export const StatisticsCardStyled = styled.li`
  flex: 1 1 20%;
  min-width: 20rem;
  max-width: 40rem;
  box-sizing: border-box;
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  gap: 1rem;
  padding: 1.6rem 1rem;
  border-radius: 10px;
  background-color: ${colors.neutral.white};
  color: ${colors.neutral[900]};
`;

export const CardQuantityStyled = styled.p`
  ${typography.bold[24]}
  margin: 0;
  text-align: center;
`;

export const CardTitleStyled = styled.h3`
  ${typography.regular[16]}
  margin: 0;
  text-align: center;
`;
